// extracted by mini-css-extract-plugin
export default {"form":"SignUpModal_form__vG323"};